module.exports = __webpack_public_path__ + "static/Kwera_Credits_Contact-Jacob-83e5f27d333c211c7c8e9488cd27c833.png";